<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">クロス商品設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h2>クロス対象商品情報</h2>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">媒体</label>
              <div class="list-input-content">
                <input type="text" [value]="kymw4802Model.mediumContent" readonly>
              </div>
              <label class="list-input-title">Pコード</label>
              <div class="list-input-content">
                <input type="text" class="pcode" [(ngModel)]="kymw4802Model.pcode" readonly>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">企画回</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" [(ngModel)]="kymw4802Model.catalogId" readonly>
              </div>
              <label class="list-input-title">商品名</label>
              <div class="list-input-content">
                <input type="text" class="guide-goods-name" [(ngModel)]="kymw4802Model.guideGoodsName" readonly>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" [(ngModel)]="kymw4802Model.orderCode" readonly>
              </div>
              <label class="list-input-title">規格名</label>
              <div class="list-input-content">
                <input type="text" class="guide-standard-name" [(ngModel)]="kymw4802Model.guidsStandardName" readonly>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2>過去クロス商品設定一覧</h2>
          <label>過去に行ったクロス商品設定を元に、今回企画回のクロス商品設定を行うことができます。</label><br>
          <label>※前画面で選択したクロス対象商品が<span class="red">赤文字</span>で表示されます。</label>
          <wj-flex-grid #dtg_CrossGoodsList [style.width.px]="1623" [style.height.px]="580"
            [itemsSource]="kymw4802Model.crossGoodsList" [allowMerging]="'ColumnHeaders'" [allowDragging]="'None'"
            horizontalScrollPolicy="'off'" [headersVisibility]="'Column'" [selectionMode]="'Row'"
            verticalScrollPolicy="'on'" [allowSorting]="false" [autoRowHeights]="true" forcedEnabledMode="true"
            [tabindex]="0" (selectionChanged)="crossGoodsListChangedHandler();">
            <wj-flex-grid-column [header]="'直近企画回'" [width]="100" [binding]="'DelivCatalogId'" [isReadOnly]="true" [minWidth]="5">
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'設定媒体'" [width]="112" [binding]="'MediumName'" [isReadOnly]="true" [minWidth]="5">
            </wj-flex-grid-column>

            <ng-template ngFor let-data [ngForOf]="kymw4802Model.displayList" let-i="index">
              <wj-flex-grid-column [header]="'Pコード'" [width]="colWidths['pcode']" [isReadOnly]="true" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div class="red first-cell" *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode === kymw4802Model.pcode">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode}}
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode !== kymw4802Model.pcode" class="first-cell">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'商品名'" [width]="colWidths['guideGoodsName']" [isReadOnly]="true" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div class="red" *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode === kymw4802Model.pcode">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].GuideGoodsName}}
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode !== kymw4802Model.pcode">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].GuideGoodsName}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'規格名'" [width]="colWidths['guideStandardName']" [isReadOnly]="true" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div class="red" *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode === kymw4802Model.pcode">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].GuideStandardName}}
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode !== kymw4802Model.pcode">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].GuideStandardName}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'子コマ配置'" [width]="colWidths['childKoma']" [isReadOnly]="true" [align]="'center'" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div class="red" *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].ChildKomaSettings === '1' && kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode === kymw4802Model.pcode">
                    〇
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].ChildKomaSettings === '1' && kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].PCode !== kymw4802Model.pcode">
                    〇
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].ChildKomaSettings === '0'">
                    -
                  </div>
                  <div *ngIf="kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].ChildKomaSettings === '-'">
                    {{kymw4802Model.crossGoodsMap[cell.item.DelivCatalogId][i].ChildKomaSettings}}
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </ng-template>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" class="btn-primary" (click)="eventBtnSet_CLICKHandler()" [disabled]="disabledSetBtn" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" forcedEnabledMode="true" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
